module.exports = __webpack_public_path__ + "static/media/(H)-Artesanato-13.07102827.jpg";